/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Stale_VersionInputs */

const fr_error_stale_version = /** @type {(inputs: Error_Stale_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fiche de ce collaborateur a changé pendant votre saisie. Rechargez et réessayez.`)
};

const en_error_stale_version = /** @type {(inputs: Error_Stale_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person changed while you were editing. Reload and try again.`)
};

/**
* | output |
* | --- |
* | "This person changed while you were editing. Reload and try again." |
*
* @param {Error_Stale_VersionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_stale_version = /** @type {((inputs?: Error_Stale_VersionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Stale_VersionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_stale_version(inputs)
	return fr_error_stale_version(inputs)
});